import { FC, useMemo, useState } from "react";
import ListingFilterSelectComponent from "../../../../../../../common/components/listing/filter/select/listing-filter-select.component";
import { useAppContext } from "../../../../../../../context/app.context";
import BillingsTaxiTransferredOrderListingFilter from "../../types/billings-taxi-transferred-order-listing-filter";
import BillingsTaxiTransferredOrderListingFilterSelectOption from "../../types/billings-taxi-transferred-order-listing-filter-select-option";
import billingsTaxiTransferredOrderListingFilterHelper from "../../helper/billings-taxi-transferred-order-listing-filter.helper";

type BillingsTaxiTransferredOrderListingFiltersSelectProps = {
  filters: BillingsTaxiTransferredOrderListingFilter[];
  onAddNewFilter: (filter: BillingsTaxiTransferredOrderListingFilter) => void;
};

const BillingsTaxiTransferredOrderListingFiltersSelectComponent: FC<
  BillingsTaxiTransferredOrderListingFiltersSelectProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const [searchInputValue, setSearchInputValue] = useState("");

  const searchSelectOptions: BillingsTaxiTransferredOrderListingFilterSelectOption[] =
    useMemo(() => {
      return billingsTaxiTransferredOrderListingFilterHelper.getSelectOptions(
        searchInputValue,
        props.filters
      );
    }, [searchInputValue, props.filters, selectedAppLanguage]);

  const onFilterSelect = (
    filter: BillingsTaxiTransferredOrderListingFilterSelectOption
  ) => {
    props.onAddNewFilter(filter.value);
  };

  return (
    <ListingFilterSelectComponent
      onChange={(option) =>
        onFilterSelect(
          option as BillingsTaxiTransferredOrderListingFilterSelectOption
        )
      }
      options={searchSelectOptions}
      inputValue={searchInputValue}
      onInputChange={setSearchInputValue}
      idForTesting="billings-taxi-transferred-order-listing-filter"
    />
  );
};

export default BillingsTaxiTransferredOrderListingFiltersSelectComponent;
